import * as React from 'react';
function isNumberStr(str) {
    return typeof str === 'string' && !isNaN(parseFloat(str));
}
export function getNumFromStr(val) {
    return isNumberStr(`${val}`) ? formatCurrency(`${val}`) : val;
}
function formatCurrency(val) {
    return Number(val).toLocaleString('zh-CN');
}
export const FormatCurrencyWithUnit = (props) => {
    const { value } = props;
    if (typeof value === 'object') {
        const amount = value?.amount;
        const currency = value?.currency;
        return (React.createElement(React.Fragment, null,
            getNumFromStr(amount),
            " ",
            currency));
    }
    return value ? React.createElement(React.Fragment, null, getNumFromStr(value)) : null;
};
